import { rem, radius, token } from '@thiememeulenhoff/lit-sdk';
import { indicatorSizeMap } from '@thiememeulenhoff/types';
import { css } from 'lit';

export const indicatorStyles = css`
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }

  :host {
    align-items: center;
    border-radius: ${radius('extra-large')};
    color: ${token('indicator-foreground-default')};
    display: flex;
    justify-content: center;
  }

  :host([size='small']) {
    block-size: ${rem(indicatorSizeMap.small)};
    flex-basis: ${rem(indicatorSizeMap.small)};
    font-size: ${rem(indicatorSizeMap.small - 6)};
    inline-size: ${rem(indicatorSizeMap.small)};
  }

  :host([size='medium']) {
    block-size: ${rem(indicatorSizeMap.medium)};
    flex-basis: ${rem(indicatorSizeMap.medium)};
    font-size: ${rem(indicatorSizeMap.medium - 10)};
    inline-size: ${rem(indicatorSizeMap.medium)};
  }

  :host([type='todo']),
  :host([type='empty']) {
    background-color: ${token('indicator-neutral-background-default')};
    color: ${token('indicator-foreground-default')};
  }

  :host([type='done']) {
    background-color: ${token('indicator-done-background-default')};
    color: ${token('indicator-done-foreground-default')};
  }

  :host([type='correct']) {
    background-color: ${token('indicator-correct-background-default')};
    color: ${token('indicator-correct-foreground-default')};
  }

  :host([type='incorrect']) {
    background-color: ${token('indicator-incorrect-background-default')};
    color: ${token('indicator-incorrect-foreground-default')};
  }

  :host([type='loading']) {
    animation: spin 2s linear infinite;
    background-color: ${token('indicator-neutral-background-default')};
    color: ${token('indicator-loading-foreground-default')};
  }

  :host([type='predefined']) {
    color: ${token('indicator-predefined-foreground-default')};
  }
`;
